import { Request } from '../../../httpClient/serverApi/requests/Request';

export let UpdateBooleanServerSettingNames = {
  embeddedCredentialsEnabled:               'embeddedCredentialsEnabled',
  schedulingEnabled:                        'schedulingEnabled',
  savedPasswordsEnabled:                    'savedPasswordsEnabled',
  savedAccessTokensEnabled:                 'savedAccessTokensEnabled',
  guestEnabled:                             'guestEnabled',
  scheduledActiveDirectorySyncEnabled:      'scheduledActiveDirectorySyncEnabled',
  refreshTokensEnabled:                     'refreshTokensEnabled',
  personalSandboxEnabled:                   'personalSandboxEnabled',
  personalSandboxByDefaultEnabled:          'personalSandboxByDefaultEnabled'
};

export interface IUpdateBooleanServerSettingParams {
  setting: string;
  value: boolean;
}

export interface IUpdateBooleanServerSettingResult {
}

export class UpdateBooleanServerSettingRequest extends Request<IUpdateBooleanServerSettingParams, IUpdateBooleanServerSettingResult> {
  constructor(params: IUpdateBooleanServerSettingParams) {
    super('updateBooleanServerSetting', params);
  }
}
